<template>
  <svg
    class="powerbilogo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M3.25852 17.6624C2.57205 17.6624 2 17.1132 2 16.4038V13.1088C2 12.4223 2.54917 11.8503 3.25852 11.8503C3.94499 11.8503 4.51704 12.3995 4.51704 13.1088V16.4038C4.49416 17.0903 3.94499 17.6624 3.25852 17.6624ZM8.20108 17.548V11.8274C8.20108 11.1409 7.6519 10.5689 6.94255 10.5689C6.25609 10.5689 5.68403 11.1181 5.68403 11.8274V17.548C5.68403 18.2344 6.23321 18.8065 6.94255 18.8065C7.62902 18.7836 8.20108 18.2344 8.20108 17.548ZM11.8851 18.8065V10.6375C11.8851 9.95106 11.3359 9.37901 10.6266 9.37901C9.94012 9.37901 9.36807 9.92818 9.36807 10.6375V18.8065C9.36807 19.4929 9.91724 20.065 10.6266 20.065C11.3359 20.065 11.8851 19.4929 11.8851 18.8065ZM15.592 19.9735V9.33324C15.592 8.64678 15.0429 8.07472 14.3335 8.07472C13.647 8.07472 13.075 8.6239 13.075 9.33324V19.9735C13.075 20.6599 13.6242 21.232 14.3335 21.232C15.02 21.232 15.592 20.6599 15.592 19.9735ZM21.0609 6.51873L4.37975 1.64482C4.26534 1.62194 4.12804 1.59906 4.01363 1.59906C3.30429 1.59906 2.68647 2.17112 2.68647 2.92623V10.7977H3.6704V2.92623C3.6704 2.72029 3.83058 2.60588 3.99075 2.60588C4.01363 2.60588 4.0594 2.60588 4.08228 2.62876L20.7634 7.50267C20.9007 7.54843 20.9922 7.66284 20.9922 7.82302V18.3031C20.9922 18.509 20.8321 18.6234 20.6719 18.6234C20.649 18.6234 20.6032 18.6234 20.5803 18.6005L16.7819 17.4793V18.5319L20.3058 19.5616C20.4202 19.6074 20.5575 19.6074 20.6719 19.6074C21.3812 19.6074 21.999 19.0353 21.999 18.2802V7.80014C22.0219 7.2052 21.6329 6.67891 21.0609 6.51873Z"
      fill="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'AscPowerBiIcon',
}
</script>

<style lang="scss" scoped>
.powerbilogo {
  fill: currentColor;
}

path {
  stroke: currentColor;
}
</style>
